import * as React from 'react';
import styled from 'styled-components';
import { colors } from '../colors/color';

type ProgressBarProps = {
    height?:number,
    completionPct?:number,
    emptyColor?:string,
    fillColor?:string,
}
export function ProgressBar(props:ProgressBarProps):JSX.Element
{
    const totalHeight = Math.max(4, props.height || 16);
    const pct = Math.max(0, Math.min(100, props.completionPct || 0));

    return (
        <StyledTrack height={totalHeight} emptyColor={props.emptyColor || '#ddd'}>
            <StyledFill fillColor={props.fillColor || colors.graphs.progressBar} widthPct={pct} />
        </StyledTrack>
    );
}

const StyledTrack = styled.div<{height:number, emptyColor:string}>`
    width: 100%;
    height:${props => props.height}px;
    background-color:${props => props.emptyColor};
    border-radius: 4px;
`;

const StyledFill = styled.div<{fillColor:string, widthPct:number}>`
    height: 100%;
    width:${props => props.widthPct}%;
    background-color:${props => props.fillColor};
    border-radius: 4px;
    transition: width 1s;
`;